import { useState } from 'react';
import { CloudOff, ListChecks, RefreshCw } from 'lucide-react';
import { useI18n } from '../i18n';
import { createSettings, defaultSettings } from '../domain/actions';
import { setMeta } from '../db/db';
import { Field } from '../ui/Field';
import { LogoMark } from '../ui/Logo';
import { AccountBenefits } from './AccountInfo';
import { hhmmToMinutes, minutesToHHMM } from '../ui/format';

export function Onboarding() {
  const { t, m, tag } = useI18n();
  const base = defaultSettings(tag);
  const [dayStart, setDayStart] = useState(base.dayStartMinutes);
  const [weekStart, setWeekStart] = useState(base.weekStartInitial);
  const [busy, setBusy] = useState(false);

  return (
    <main className="onboarding" id="main">
      <form
        className="onboarding__card"
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          await createSettings({ ...base, dayStartMinutes: dayStart, weekStartInitial: weekStart });
          await setMeta('firstUseAt', Date.now());
          try {
            await navigator.storage?.persist?.();
          } catch {
            /* opcional */
          }
        }}
      >
        <div className="logo">
          <LogoMark size={44} />
          <span style={{ fontWeight: 800, fontSize: 'var(--fs-xl)' }}>{m.app.name}</span>
        </div>
        <h1>{t('onboarding.title')}</h1>
        <ul className="stack" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          <li className="row" style={{ alignItems: 'flex-start' }}>
            <ListChecks size={22} aria-hidden="true" style={{ flex: 'none', color: 'var(--primary)' }} />
            <span>{t('onboarding.p1')}</span>
          </li>
          <li className="row" style={{ alignItems: 'flex-start' }}>
            <CloudOff size={22} aria-hidden="true" style={{ flex: 'none', color: 'var(--primary)' }} />
            <span>{t('onboarding.p2')}</span>
          </li>
          <li className="row" style={{ alignItems: 'flex-start' }}>
            <RefreshCw size={22} aria-hidden="true" style={{ flex: 'none', color: 'var(--primary)' }} />
            <span>{t('onboarding.p3')}</span>
          </li>
        </ul>
        <details className="disclosure">
          <summary>{t('onboarding.accountMore')}</summary>
          <AccountBenefits />
        </details>
        <div className="form-section">
          <Field label={t('onboarding.dayStart')} help={t('onboarding.dayStartHelp')}>
            {(p) => <input {...p} type="time" className="input num" value={minutesToHHMM(dayStart)} onChange={(e) => e.target.value && setDayStart(hhmmToMinutes(e.target.value))} />}
          </Field>
          <Field label={t('onboarding.weekStart')}>
            {(p) => (
              <select {...p} className="select" value={weekStart} onChange={(e) => setWeekStart(Number(e.target.value))}>
                {m.weekdays.long.map((name, i) => (
                  <option key={i} value={i + 1}>
                    {name}
                  </option>
                ))}
              </select>
            )}
          </Field>
        </div>
        <button type="submit" className="btn btn--primary btn--block" disabled={busy}>
          {t('onboarding.start')}
        </button>
      </form>
    </main>
  );
}
